module.exports = __webpack_public_path__ + "static/media/biocair.a336716a.png";